import { Box, Tab, Tabs } from '@mui/material'
import PageHeaderWithIcons from '@/components/heder/PageHeaderWithIcons'
import { useNavigate, Outlet, useLocation, useParams } from 'react-router-dom'
import { useAppTheme } from '@/theme/ThemeContext'

const Setting = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { siteId } = useParams()
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  const TEXT_COLOR = isDarkMode ? '#FFFFFF' : '#003F61'

  const options = [
    { label: 'משתמש', route: 'users', value: 0 },
    { label: 'ארגון', route: 'organization', value: 1 },
    { label: 'קטגוריות', route: 'categories', value: 2 },
  ]

  const value = options.findIndex(opt => location.pathname.includes(opt.route)) !== -1 
    ? options.findIndex(opt => location.pathname.includes(opt.route)) 
    : 0

  const handleChange = (_: unknown, newValue: number) => {
    navigate(`/${siteId}/settings/${options[newValue].route}`)
  }
  return (
    <Box sx={{ px: '49px', display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <PageHeaderWithIcons title="הגדרות" />
      <Box sx={{ borderBottom: 1, borderColor: isDarkMode ? '#374151' : 'divider', marginTop: '20px' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            direction: 'rtl',
            '& .MuiTabs-indicator': {
              display: 'none', // Hide the jumpy absolute indicator
            },
          }}
        >
          {options.map(option => (
            <Tab
              key={option.value}
              sx={{
                outline: 'none !important',
                color: TEXT_COLOR,
                textAlign: 'right',
                fontFamily: 'Rubik',
                fontStyle: 'normal',
                lineHeight: '24px',
                minWidth: 'auto',
                px: 2,
                '&.Mui-selected': { 
                  color: TEXT_COLOR,
                  borderBottom: '3px solid #72A4EB', // Custom indicator that moves with the text
                },
              }}
              label={option.label}
              value={option.value}
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', pr: 3 }}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default Setting
